import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import "./ProductImages.css";
import DashSideBar from "../../shared/DashSideBar";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import Resizer from "react-image-file-resizer";

function ProductImages() {
  let emptyProductImage = {
    id: null,
    alt: "",
    sortOrder: null,
    imageUrl: null,
    product: { id: null, name: "" },
  };

  const [productImages, setProductImages] = useState(null);
  const [products, setProducts] = useState(null);
  const [productImageDialog, setProductImageDialog] = useState(false);
  const [deleteProductImageDialog, setDeleteProductImageDialog] =
    useState(false);
  const [deletProductImagesDialog, setDeletProductImagesDialog] =
    useState(false);
  const [productImage, setProductImage] = useState(emptyProductImage);
  const [selectedProductImages, setSelectedProductImages] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const [file, setFile] = useState(null);

  const isFetched = useRef(false);
  useEffect(() => {
    if (!isFetched.current) {
      getProductImages();
      getProducts();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);

  const getProductImages = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/ProductImages/ProductImagesResponse"
      );

      if (response.data) {
        setProductImages(response.data);
      }
    } catch (error) {
      console.error("Error fetching product Images:", error);
    }
  };
  const getProducts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Products/ProductNameResponse"
      );

      if (response.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1000, // width
        1000, // height
        "WEBP", // format (can be "JPEG", "PNG", "WEBP")
        100, // quality (0-100)
        0, // rotation (optional)
        (uri) => {
          resolve(uri);
        },
        "blob" // output type (blob or base64)
      );
    });

  const openNew = () => {
    setProductImage(emptyProductImage);
    setSubmitted(false);
    setProductImageDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProductImageDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductImageDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeletProductImagesDialog(false);
  };

  const saveProductImage = async () => {
    setLoading(true);
    setSubmitted(true);

    if (productImage.alt.trim()) {
      let _productImages = [...productImages];
      let _productImage = { ...productImage };

      try {
        if (productImage.id) {
          const index = findIndexById(productImage.id);

          let formData = new FormData();
          formData.append("Alt", _productImage.alt);
          formData.append("ProductId", _productImage.product.id);
          formData.append(
            "SortOrder",
            isNaN(parseInt(_productImage.sortOrder))
              ? 1
              : parseInt(_productImage.sortOrder)
          );

          if (file != null) {
            formData.append("ImageUrl", file);
          }

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL +
              "api/ProductImages/" +
              productImage.id,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (response.data.success) {
            _productImages[index] = _productImage;
            if (response.data.fileName !== "")
              _productImages[index].imageUrl = response.data.fileName;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Image Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Image Not Updated",
              life: 3000,
            });
          }
        } else {
          _productImage.id = createId();
          let formData = new FormData();
          formData.append("Alt", _productImage.alt);
          formData.append("ProductId", _productImage.product.id);
          formData.append(
            "SortOrder",
            isNaN(parseInt(_productImage.sortOrder))
              ? 1
              : parseInt(_productImage.sortOrder)
          );
          formData.append("ImageUrl", file);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/ProductImages",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (response.data.success) {
            _productImages.push(response.data.productimage);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Image Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Image Not Added",
              life: 3000,
            });
          }
        }

        setProductImages(_productImages);
        setProductImageDialog(false);
        setProductImage(emptyProductImage);
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong. Please try again.",
          life: 3000,
        });
      } finally {
        setLoading(false);
        setFile(null);
      }
    }
  };

  const editProduct = (productImage) => {
    setProductImage({ ...productImage });
    setProductImageDialog(true);
  };

  const confirmDeleteProduct = (productImage) => {
    setProductImage(productImage);
    setDeleteProductImageDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_URL + "api/ProductImages/" + productImage.id
    );
    setLoading(false);
    if (response.data.success) {
      let _productImages = productImages.filter(
        (val) => val.id !== productImage.id
      );
      setProductImages(_productImages);
      setDeleteProductImageDialog(false);
      setProductImage(emptyProductImage);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Product Image Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Product Image Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < productImages.length; i++) {
      if (productImages[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const imageBodyTemplate = (rowData) => {
    return (
      <img
        loading="lazy"
        src={process.env.REACT_APP_BACKEND_URL_IMAGES + rowData.imageUrl}
        alt={rowData.imageUrl}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeletProductImagesDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedProductImages.map((productImage) => productImage.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/ProductImages/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _productImages = productImages.filter(
        (val) => !selectedProductImages.includes(val)
      );
      console.log(_productImages);
      setProductImages(_productImages);
      setDeletProductImagesDialog(false);
      setSelectedProductImages(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "productImages Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "productImages Not Deleted",
        life: 3000,
      });
    }
  };

  const onProductChange = (selectedOption) => {
    const selectedProductId = selectedOption.value; // Assuming 'value' contains the selected category ID

    const selectedProduct = products.find(
      (product) => product.id === selectedProductId
    );

    setProductImage({
      ...productImage,
      product: { id: selectedOption.value, name: selectedProduct.name },
    });
  };
  const onFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];

    const resizedImage = await resizeFile(file); // Resize the image

    // Create a new File from the blob with the correct name and MIME type
    const newFile = new File([resizedImage], file.name, {
      type: resizedImage.type || "image/jpeg", // Set MIME type
    });
    setFile(newFile);

    setProductImage((prevProductImage) => ({
      ...prevProductImage,
      imageUrl: process.env.REACT_APP_BACKEND_URL_IMAGES + newFile.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _productImage = { ...productImage };

    _productImage[`${name}`] = val;

    setProductImage(_productImage);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Product Images</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedProductImages || !selectedProductImages.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Product Images</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={saveProductImage}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="productImage-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={productImages}
              selection={selectedProductImages}
              onSelectionChange={(e) => setSelectedProductImages(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Product Images"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="imageUrl"
                header="Image"
                body={imageBodyTemplate}
              ></Column>
              <Column
                field="alt"
                header="Name"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                field="sortOrder"
                sortable
                header="Order"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="product.name"
                header="Product"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={productImageDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Product Image Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            {productImage.imageUrl && (
              <div className="image-container">
                <img
                  loading="lazy"
                  src={
                    process.env.REACT_APP_BACKEND_URL_IMAGES +
                    productImage.imageUrl
                  }
                  alt={productImage.imageUrl}
                  className="product-image block m-auto pb-3"
                />
              </div>
            )}
            <div className="field">
              <label htmlFor="name" className="font-bold mb-1">
                Name :
              </label>
              <InputText
                id="name"
                value={productImage.alt ?? ""}
                onChange={(e) => onInputChange(e, "alt")}
                required
                autoFocus
                className={classNames({
                  "p-invalid": submitted && !productImage.alt,
                })}
              />
              {submitted && !productImage.alt && (
                <small className="p-error">Name is required.</small>
              )}
            </div>

            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={productImage.sortOrder ?? 1}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !productImage.sortOrder,
                })}
              />
              {submitted && !productImage.sortOrder && (
                <small className="p-error">sortOrder is required.</small>
              )}
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Porject</label>
              {products != null ? (
                <Dropdown
                  value={productImage.product.id}
                  options={products.map((product) => ({
                    value: product.id,
                    label: product.name,
                  }))}
                  onChange={onProductChange}
                  placeholder="Select a Product"
                />
              ) : (
                <p>Loading products...</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="image" className="mt-3 mb-1 font-bold">
                Image :
              </label>
              <FileUpload
                name="image"
                mode="basic"
                accept="image/*"
                onSelect={onFileUpload}
              />
            </div>
          </Dialog>

          <Dialog
            visible={deleteProductImageDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {productImage && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{productImage.name}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={deletProductImagesDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {productImage && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected products images?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default ProductImages;
